import { authenType } from '../action/types';

const initialState = {
    userInfo: undefined,
    isAuthenticate: false,
    error: undefined,
}

const authenReducer = (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case authenType.SUCCESS:
            return {
                ...state,
                isAuthenticate: true,
                userInfo: payload
            }
        case authenType.FAIL:
            return {
                ...state,
                userInfo: undefined,
                isAuthenticate: false,
                error: payload
            }
        case authenType.UPDATE_PROFILE: 
            return {
                ...state,
                isAuthenticate: true,
                userInfo: payload
            }
        case authenType.SIGN_OUT_REQUEST: 
            return {
                ...state,
                userInfo: undefined,
                isAuthenticate: false,
            }
        default:
            return state;
    }

}

export default authenReducer;